export const ISOLEMENT = [
  { libelle: '', value: null },
  { libelle: 'general.oui', value: true },
  { libelle: 'general.non', value: false },
];

export const DROITE = 'Droite';
export const GAUCHE = 'Gauche';

export const VISIBLE_SUR_LA = [
  { libelle: '', value: null },
  { libelle: 'materiel.droite', value: DROITE },
  { libelle: 'materiel.gauche', value: GAUCHE },
];

export const NON_GERE = 'NonGere';
export const DECLARATION_EN_ATTENTE = 'DeclarationEnAttente';
export const DECLARATION_FAITE = 'DeclarationFaite';

export const LISTE_ETAT_FIL_DE_LEAU = [
  { code: NON_GERE, libelle: 'materiel.etatFilDeLeau.nonGere' },
  { code: DECLARATION_EN_ATTENTE, libelle: 'materiel.etatFilDeLeau.declarationEnAttente' },
  { code: DECLARATION_FAITE, libelle: 'materiel.etatFilDeLeau.declarationFaite' },
];
